import React from "react";

export default function Performance() {
  const metrics = [
    { year: "2015-16", trained: 2994, placed: 2096 },
    { year: "2016-17", trained: 3593, placed: 2551 },
    { year: "2017-18", trained: 3767, placed: 2712 },
    { year: "2018-19", trained: 3367, placed: 2492 },
    { year: "2019-20", trained: 4228, placed: 2960 },
    { year: "2020-21", trained: 4488, placed: 3142 },
    { year: "2021-22", trained: 2430, placed: 1701 },
    { year: "2022-23", trained: 1490, placed: 1043 },
    { year: "2023-24", trained: 1247, placed: 873 },
  ];

  const totalTrained = 27604;
  const totalPlaced = 19570;
  const overallPlacementRate = Math.round(
    (totalPlaced / totalTrained) * 100
  );

  return (
    <section
      id="performance"
      className="py-5 position-relative overflow-hidden"
      style={{
        background:
          "linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <div className="row g-5">
          {/* Left Side */}
          <div className="col-xl-4 col-lg-5">
            <div
              className="sticky-xl-top"
              style={{ top: "100px", zIndex: 1 }}
            >
              {/* Badge */}
              <div className="performance-badge mb-3">
                <i className="bi bi-graph-up-arrow"></i>
                <span>Impact & Performance Tracking</span>
              </div>

              {/* Heading */}
              <h2 className="display-6 fw-bold text-dark mb-4">
                Empowering Communities Through
                <span className="text-primary d-block">
                  Skill & Employment
                </span>
              </h2>

              <p className="text-secondary lh-lg mb-4">
                SFW has successfully implemented employment-linked
                training programs for youth belonging to marginalized
                communities including SC, ST, OBC, and Minority groups
                across Uttar Pradesh and Madhya Pradesh.
              </p>

              {/* Stats */}
              <div className="row g-3 mb-4">
                <div className="col-6">
                  <div className="stats-card">
                    <div className="stats-icon bg-primary bg-opacity-10 text-primary">
                      <i className="bi bi-mortarboard-fill"></i>
                    </div>

                    <h3 className="fw-bold text-dark mb-1">
                      {totalTrained.toLocaleString("en-IN")}
                    </h3>

                    <small className="text-muted fw-semibold">
                      Total Trained
                    </small>
                  </div>
                </div>

                <div className="col-6">
                  <div className="stats-card">
                    <div className="stats-icon bg-success bg-opacity-10 text-success">
                      <i className="bi bi-briefcase-fill"></i>
                    </div>

                    <h3 className="fw-bold text-dark mb-1">
                      {totalPlaced.toLocaleString("en-IN")}
                    </h3>

                    <small className="text-muted fw-semibold">
                      Total Placed
                    </small>
                  </div>
                </div>
              </div>

              {/* Highlight Card */}
              <div className="highlight-card position-relative overflow-hidden">
                <div className="highlight-bg">
                  <i className="bi bi-pie-chart-fill"></i>
                </div>

                <div className="position-relative">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-white-50 small text-uppercase fw-semibold">
                      Overall Placement Success
                    </span>

                    <span className="badge bg-white text-primary px-3 py-2 rounded-pill">
                      {overallPlacementRate}%
                    </span>
                  </div>

                  <h5 className="fw-bold text-white mb-3">
                    Strong Placement Performance
                  </h5>

                  <p className="text-white-50 mb-0 lh-lg">
                    Demonstrating consistent training quality,
                    industrial alignment, and employment conversion
                    across multiple sectors and regions.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-xl-8 col-lg-7">
            <div className="performance-table-card">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                <div>
                  <h4 className="fw-bold text-dark mb-1">
                    <i className="bi bi-calendar-check text-primary me-2"></i>
                    Year-wise Performance Metrics
                  </h4>

                  <p className="text-muted small mb-0">
                    Audited training and placement records
                  </p>
                </div>

                <span className="table-badge">
                  <i className="bi bi-patch-check me-1"></i>
                  Verified Data
                </span>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table align-middle performance-table mb-0">
                  <thead>
                    <tr>
                      <th>Financial Year</th>
                      <th className="text-center">
                        Trained Candidates
                      </th>
                      <th className="text-center">
                        Placed Candidates
                      </th>
                      <th className="text-end">
                        Placement Rate
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {metrics.map((row, idx) => {
                      const rate = Math.round(
                        (row.placed / row.trained) * 100
                      );

                      let progressColor = "bg-success";

                      if (rate < 70) {
                        progressColor = "bg-warning";
                      }

                      return (
                        <tr key={idx}>
                          <td className="fw-semibold text-dark">
                            {row.year}
                          </td>

                          <td className="text-center">
                            <span className="metric-badge metric-primary">
                              {row.trained.toLocaleString("en-IN")}
                            </span>
                          </td>

                          <td className="text-center">
                            <span className="metric-badge metric-success">
                              {row.placed.toLocaleString("en-IN")}
                            </span>
                          </td>

                          <td className="text-end">
                            <div className="d-flex align-items-center justify-content-end gap-3">
                              <span className="fw-bold text-dark small">
                                {rate}%
                              </span>

                              <div
                                className="progress d-none d-sm-flex"
                                style={{
                                  width: "110px",
                                  height: "8px",
                                  background: "#e2e8f0",
                                }}
                              >
                                <div
                                  className={`progress-bar rounded-pill ${progressColor}`}
                                  style={{
                                    width: `${rate}%`,
                                  }}
                                ></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                  {/* Footer */}
                  <tfoot>
                    <tr>
                      <td className="fw-bold text-uppercase">
                        Total
                      </td>

                      <td className="text-center fw-bold text-primary">
                        {totalTrained.toLocaleString("en-IN")}
                      </td>

                      <td className="text-center fw-bold text-success">
                        {totalPlaced.toLocaleString("en-IN")}
                      </td>

                      <td className="text-end fw-bold">
                        {overallPlacementRate}%
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .performance-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          background: rgba(25,135,84,0.1);
          color: #198754;
          padding: 0.7rem 1rem;
          border-radius: 999px;
          font-size: 0.8rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.7px;
        }

        .stats-card {
          background: white;
          border-radius: 22px;
          padding: 1.5rem;
          text-align: center;
          border: 1px solid #eef2f7;
          box-shadow: 0 4px 20px rgba(0,0,0,0.03);
          transition: all 0.3s ease;
          height: 100%;
        }

        .stats-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.06);
        }

        .stats-icon {
          width: 52px;
          height: 52px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
          font-size: 1.2rem;
        }

        .highlight-card {
          background: linear-gradient(135deg, #2563eb, #1d4ed8);
          border-radius: 28px;
          padding: 2rem;
          color: white;
          box-shadow: 0 1rem 2rem rgba(37,99,235,0.18);
        }

        .highlight-bg {
          position: absolute;
          right: -10px;
          bottom: -10px;
          opacity: 0.08;
          font-size: 8rem;
          color: white;
        }

        .performance-table-card {
          background: white;
          border-radius: 30px;
          padding: 2rem;
          border: 1px solid #eef2f7;
          box-shadow: 0 10px 30px rgba(0,0,0,0.04);
        }

        .table-badge {
          background: rgba(13,110,253,0.08);
          color: #0d6efd;
          padding: 0.6rem 1rem;
          border-radius: 999px;
          font-size: 0.8rem;
          font-weight: 700;
        }

        .performance-table thead th {
          background: #f8fafc;
          color: #64748b;
          font-size: 0.82rem;
          text-transform: uppercase;
          letter-spacing: 0.7px;
          border-bottom: 1px solid #e2e8f0;
          padding: 1rem;
        }

        .performance-table tbody td {
          padding: 1rem;
          border-color: #f1f5f9;
          transition: all 0.2s ease;
        }

        .performance-table tbody tr:hover {
          background: #f8fafc;
        }

        .metric-badge {
          padding: 0.55rem 1rem;
          border-radius: 999px;
          font-weight: 700;
          font-size: 0.9rem;
          display: inline-block;
          min-width: 95px;
        }

        .metric-primary {
          background: rgba(13,110,253,0.1);
          color: #0d6efd;
        }

        .metric-success {
          background: rgba(25,135,84,0.1);
          color: #198754;
        }

        .performance-table tfoot td {
          background: #f8fafc;
          padding: 1rem;
          border-top: 2px solid #e2e8f0;
        }

        @media (max-width: 768px) {
          .performance-table-card {
            padding: 1.25rem;
          }

          .highlight-card {
            padding: 1.5rem;
          }

          .display-6 {
            font-size: 2rem;
          }
        }
      `}</style>
    </section>
  );
}